import { z } from 'zod'

export const nomineeSchema = z.object({
  givenName: z.string().min(1, 'Given name is required'),
  familyName: z.string().min(1, 'Family name is required'),
  email: z.string().email('A valid email is required'),
})

export const userOrNomineeSchema = z
  .object({
    userId: z.number().optional(),
    nominee: nomineeSchema.optional(),
  })
  .refine((value) => value.userId != null || value.nominee != null, {
    message: 'Add a person',
  })

export const applicationAssignmentSchema = z.object({
  userId: z.number().optional(),
  nominee: nomineeSchema.optional(),
  roleIds: z.array(z.number()),
})
